import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { ShieldOff } from "lucide-react";

/**
 * Page /acces-refuse
 *
 * Affichée quand le backend refuse l'accès (403 GEO_BLOCKED ou IP_BLOCKED)
 * via le middleware de blocage pays / IP. Le front est servi séparément de
 * l'API : sans cette page, un visiteur bloqué verrait un site vide.
 * Aucun appel API n'est fait ici, pour éviter une boucle de redirection.
 */
export default function AccessBlocked() {
  const [params] = useSearchParams();
  const raw = params.get("reason");
  const reason = raw === "ip" || raw === "session" ? raw : "geo";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center px-4" data-testid="access-blocked-page">
      <div className="max-w-md w-full bg-white border border-stone rounded-sm p-8 text-center">
        <div className="mx-auto h-12 w-12 rounded-full bg-sand flex items-center justify-center mb-5">
          <ShieldOff className="h-6 w-6 text-graphite" />
        </div>
        <p className="text-[11px] uppercase tracking-[0.14em] text-ash mb-2">Accès refusé</p>
        <h1 className="font-serif text-2xl text-ink mb-3">
          {reason === "ip" ? "Votre adresse IP a été bloquée" : reason === "session" ? "Votre appareil a été bloqué" : "Site non disponible dans votre région"}
        </h1>
        <p className="text-sm text-graphite leading-relaxed">
          {reason === "ip"
            ? "L'accès à ce site a été restreint pour votre adresse IP."
            : reason === "session"
              ? "L'accès à ce site a été restreint pour cet appareil."
              : "Ce site n'est pas accessible depuis votre pays ou votre région actuelle."}
        </p>
        <p className="text-xs text-ash mt-6">
          Si vous pensez qu'il s'agit d'une erreur, contactez-nous par e-mail.
        </p>
      </div>
    </div>
  );
}
